import { gql } from 'graphql-request'

// Query Keys
export const CAPITAL_SITE_PAYMENT_GATEWAY_QUERY_KEY = 'CAPITAL_SITE_PAYMENT_GATEWAY_QUERY'
// Queries
export const capitalSitePaymentGatewayQuery = gql`
  query CapitalSitePaymentGateway($siteId: ID!) {
    sitePaymentGateway(siteId: $siteId) {
      siteId
      countryCode
      paymentGatewayType
      paymentGatewayPublishableKey
    }
  }
`

// Mutations
export const createStripeCapitalSessionMutation = gql`
  mutation CreateStripeCapitalSession($siteId: ID!) {
    createStripeCapitalSession(siteId: $siteId) {
      clientSecret
    }
  }
`
